module.exports = __webpack_public_path__ + "assets/d4d4f2b0b992ba05304f4d1ca7fe1e37.mp3";